import { Component, Input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { WafProfileMinimal } from '@bn/app-shield';
import { PlanType } from '@bn/app-shield/enums';
import { DashboardSharedModule } from '@bn/dashboard-shared';
import { LazyLoadDirective } from '@bn/web-ui';
import { CardComponent } from '@bn/web-ui/card/card.component';
import { AppShieldPricingTableComponent } from '../../app-shield-pricing-table/app-shield-pricing-table.component';

@Component({
  selector: 'app-shield-setup-package',
  templateUrl: './app-shield-setup-package.component.html',
  styleUrls: ['./app-shield-setup-package.component.scss'],
  imports: [AppShieldPricingTableComponent, CardComponent, DashboardSharedModule, FaIconComponent, LazyLoadDirective],
})
export class AppShieldSetupPackageComponent {
  @Input()
  public set setSelectedShieldProfile(profile: WafProfileMinimal) {
    if (profile) {
      this.selectedShieldProfile = profile;
    }
  }

  public readonly selectShieldPackage = output<number>();

  public selectedShieldProfile!: WafProfileMinimal;

  public getProfileFeatures(profile: WafProfileMinimal): string[] {
    return profile.features ? profile.features.split(',').map((feature) => feature.trim()) : [];
  }

  public onShieldPackageChange(shieldPackage: PlanType) {
    this.selectShieldPackage.emit(shieldPackage);
  }
}
